import { Outlet } from 'react-router-dom';
import { useAuth } from '@/lib/auth-context';
import { canAccessScheduling } from '@/lib/product-flags';

/**
 * Route guard for Study Scheduling. Recruiters and schedulers land here from
 * the root redirect, so a missing entitlement shows a message instead of
 * redirecting back to `/` and looping.
 */
export function SchedulingRoute() {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-primary-600" />
      </div>
    );
  }

  if (!canAccessScheduling(user)) {
    return (
      <div className="mx-auto max-w-md py-24 text-center">
        <h1 className="text-sm font-semibold text-atlas-ink">Scheduling isn&apos;t available</h1>
        <p className="mt-2 text-xs text-atlas-muted">
          Study Scheduling isn&apos;t enabled for your organization. Contact your administrator.
        </p>
      </div>
    );
  }

  return <Outlet />;
}
